import React from 'react'
import BreadCrumb from '../../components/BreadCrumb'

export default function ServiceBanner({data}) {
  return (
    <>
    <section className="servicebanner">
        <div className="container">
            <div className="col-lg-12">
                <BreadCrumb data={data?.breadcrumb} />
            </div>
        </div>

        <img src={data?.image} alt="service"/>
    </section> 
    </>
  )
}
